import { I18n } from 'aws-amplify';
import LoadingPanel from '../common/LoadingPanel';
import { Button, TextField } from '@material-ui/core';
import { useEffect, useState } from 'react';
import './SettingAI.css';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { getProjectById } from '@/service/projectService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import Constant from '../../common/constant/Constant';
import { getValue, onSubmitSetting, validateTemperature, validateMaxAiChatKnowledgeCount } from './handler/SettingAIHandler';
import { useSnackbar } from 'notistack';
import { userAtom } from '@/state/atom/userAtom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { closeTabId, panelInitDataAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import { getCorporationById } from '@/service/organizationService';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';

export default function SettingAI(props) {
    const userDetail = useRecoilValue(userAtom);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const setProjectInUseDetail = useSetRecoilState(projectInuseDetailAtom);

    const [isLoading, setIsLoading] = useState(false);
    const [settingData, setSettingData] = useState({});
    const [isChangeData, setIsChangeData] = useState(false);
    const [isOpenConfirmReset, setIsOpenConfirmReset] = useState(false);
    const [reloadPage, setReloadPage] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const [projectDetail, setProjectDetail] = useState({});
    const [isShowDialogReload, setIsShowDialogReload] = useState(false);

    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [isShowLogAiChat, setIsShowLogAiChat] = useState(false);
    const [temperature , setTemperature] = useState({value: '', error: ''});
    const [isShowMsgSettingAI, setIsShowMsgSettingAI] = useState(false);
    const [ maxAiChatKnowledgeCount, setMaxAiChatKnowledgeCount] = useState({value: '', error: ''});
    const [isShowMsgSettingMaxKnowledge, setIsShowMsgSettingMaxKnowledge] = useState(false);


    let projectInuseId = localStorageUtil.getSelectedProjectId();

    const initAISetting = {
        isInProject: false,
        isInOrg: false,
        isOutOrg: false,
    };

    useEffect(() => {
        initPageData();
    }, [reloadPage]);

    const initPageData = async () => {
        setIsLoading(true);
        let corpId = localStorageUtil.getAffiliationOrganization();
        let corpDetail = await getCorporationById(props?.API, corpId);

        let isReloadByOffRole = false;
        if (
            corpDetail &&
            [
                Constant.CORPORATION_CONTRACT_TYPE.GUEST,
                Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
            ].includes(corpDetail.contractType)
        ) {
            isReloadByOffRole = corpDetail.inviterUsingChatAI === Constant.STATUS_SERVICE_PERMISSION.OFF
        } else {
            isReloadByOffRole = corpDetail?.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.OFF;
        }

        if (isReloadByOffRole) {
            setIsLoading(false);
            setIsShowDialogReload(true);
            return;
        }

        let projectData = await getProjectById(props?.API, projectInuseId);

        if (!Utils.isEmptyObject(projectData)) {
            setProjectDetail(projectData);
            let projectSetting = projectData.projectSetting;
            let initData = { ...initAISetting };
            if (!Utils.isEmptyObject(projectSetting)) {
                projectSetting = Utils.convertJSONDataToObject(projectSetting);
                let chatAISetting = projectSetting.chatAISetting;
                let usageRange = chatAISetting.usageRange;
                let isShowLogAi = chatAISetting.isShowLogAiChat ? true : false;
                let initTemperature = chatAISetting.temperature ? chatAISetting.temperature : String(Constant.AI_TEMPERATURE_DEFAULT)
                let initMaxAiChatKnowledgeCount = chatAISetting.maxAiChatKnowledgeCount ? chatAISetting.maxAiChatKnowledgeCount : String(Constant.MAX_AI_CHAT_KNOWLEDGE_COUNT_DEFAULT)

                initData = {
                    isInProject: usageRange.includes(Constant.AI_SETTING_RANGE.IN_PROJECT),
                    isInOrg: usageRange.includes(Constant.AI_SETTING_RANGE.IN_ORG),
                    isOutOrg: usageRange.includes(Constant.AI_SETTING_RANGE.OUT_ORG),
                }

                setIsShowLogAiChat(isShowLogAi)
                setTemperature({value: initTemperature, error: ''})
                setMaxAiChatKnowledgeCount({value: initMaxAiChatKnowledgeCount, error: ''})
            }
            setSettingData(initData);
        }
        setIsChangeData(false);
        setIsLoading(false);
    }

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (isChangeData) {
                let temperatureErrorMsg = validateTemperature(temperature.value)
                let maxKnowledgeCountErrorMsg = validateMaxAiChatKnowledgeCount(maxAiChatKnowledgeCount.value)
                if (!Utils.isEmptyString(temperatureErrorMsg) || !Utils.isEmptyString(maxKnowledgeCountErrorMsg)) {
                    closePanelTab({
                        event: null,
                        panelType: props.panelType,
                        panelId: props.panelId,
                        tabId: props.tabId
                    });
                    setCloseTabIdState(0);
                    return
                };
                setIsConfirmCancelTabs(true);
            } else {
                closePanelTab({
                    event: null,
                    panelType: props.panelType,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isChangeData);
    }, [isChangeData])

    const isDisabledCancelSettingAI = () => {
        if (isChangeData) {
            return false;
        }
        return true;
    };

    const isDisabledSubmitSettingAI = () => {
        if (isChangeData) {
            let temperatureErrorMsg = validateTemperature(temperature.value)
            let maxKnowledgeCountErrorMsg = validateMaxAiChatKnowledgeCount(maxAiChatKnowledgeCount.value)
            const isError = !Utils.isEmptyString(temperatureErrorMsg) || !Utils.isEmptyString(maxKnowledgeCountErrorMsg)
            return isError ? true : false;
        }
        return true;
    };

    const onChangeData = (e, field) => {
        setIsChangeData(true);
        let settingDataClone = { ...settingData };
        let currentValue = '';
        switch (field) {
            case 'isInProject':
                currentValue = settingDataClone.isInProject;
                settingDataClone.isInProject = !currentValue;
                if (!settingDataClone.isInProject) {
                    settingDataClone.isInOrg = false;
                    settingDataClone.isOutOrg = false;
                }
                break;
            case 'isInOrg':
                currentValue = settingDataClone.isInOrg;
                settingDataClone.isInOrg = !currentValue;
                break;
            case 'isOutOrg':
                currentValue = settingDataClone.isOutOrg;
                settingDataClone.isOutOrg = !currentValue;
                break;
            default:
                break;
        }
        setSettingData(settingDataClone);
    }

    const onChangeButtonViewLogAI = (e) => {
        setIsChangeData(true);
        setIsShowLogAiChat(prev => !prev);
    }
 
    const isInProjectCheck = () => {
        return settingData.isInProject;
    }

    const handleOnChangeTemperature = (e) => {
        const inputValue = e.target.value;
        setTemperature(prev => ({
            ...prev,
            value: inputValue,
            error: ''
        }))
    
        setIsChangeData(true);
    }

    const handleOnBlurTemperature = (e) => {
        const temperatureValue = e.target.value
        const errorMsg = validateTemperature(temperatureValue)
        
        setTemperature({value: temperatureValue.trim(), error: errorMsg})
    }

    const handleCancelSetting = () => {
        let temperatureErrorMsg = validateTemperature(temperature.value)
        let maxKnowledgeCountErrorMsg = validateMaxAiChatKnowledgeCount(maxAiChatKnowledgeCount.value)
        if (!Utils.isEmptyString(temperatureErrorMsg) || !Utils.isEmptyString(maxKnowledgeCountErrorMsg)) {
            setReloadPage(Date.now().toString());
            setIsOpenConfirmReset(false);
            return
        };

        setIsOpenConfirmReset(true)
    }

    const handlerResetAISetting = async () => {
        setIsShowMsgSettingAI(false);
        setTemperature({value: String(Constant.AI_TEMPERATURE_DEFAULT), error: ''})
        setIsChangeData(true);
    }

    const handleOnChangeMaxAiChatKnowledgeCount = (e) => {
        const inputValue = e.target.value;
        setMaxAiChatKnowledgeCount(prev => ({
            ...prev,
            value: inputValue,
            error: ''
        }))
        setIsChangeData(true);
    }

    const handleOnBlurMaxAiChatKnowledgeCount = (e) => {
        const inputValue = e.target.value;
        const trimmedValue = inputValue.trim();

        const errorMsg = validateMaxAiChatKnowledgeCount(trimmedValue);

        let normalizedValue = trimmedValue;
        if (Utils.isEmptyString(errorMsg) && /^[0-9]+$/.test(trimmedValue)) {
            normalizedValue = trimmedValue.replace(/^0+(\d+)/, '$1');
        }

        setMaxAiChatKnowledgeCount({ value: normalizedValue, error: errorMsg });
    }

    const handlerResetMaxAiChatKnowledgeCount = async () => {
        setIsShowMsgSettingMaxKnowledge(false);
        setMaxAiChatKnowledgeCount({value: String(Constant.MAX_AI_CHAT_KNOWLEDGE_COUNT_DEFAULT), error: ''})
        setIsChangeData(true);
    }

    const handleSubmitSetting = () => {
        onSubmitSetting({
            projectDetail,
            settingData,
            enqueueSnackbar,
            setIsLoading,
            setReloadPage,
            userId: userDetail.id,
            setIsChangeData,
            API: props?.API,
            setIsShowDialogReload,
            isShowLogAiChat,
            setProjectInUseDetail,
            temperatureValue: temperature.value,
            maxAiChatKnowledgeCountValue: maxAiChatKnowledgeCount.value
        })
    }

    return (
        <div className="aiSetting">
            <LoadingPanel isLoading={isLoading} />
            <div className="groupSetting category-active">
                <div className="advanced-setting-onoff">
                    <h3>{I18n.get('CM-TITLE-AI-MNG')}</h3>
                    <div className="groupBtn">
                        <Button
                            variant="contained"
                            className="btn-hg32 btn-light"
                            color="primary"
                            onClick={() => handleCancelSetting()}
                            disabled={isDisabledCancelSettingAI()}
                        >
                            {I18n.get('CM-BUTTON-CANCEL')}
                        </Button>

                        <Button
                            onClick={() => handleSubmitSetting()}
                            disabled={isDisabledSubmitSettingAI()}
                            variant="contained"
                            className="btn-hg32 btn-primary"
                            color="primary"
                        >
                            {I18n.get('COMBTN011')}
                        </Button>
                    </div>
                </div>
            </div>

            <div className="groupSetting category-active">
                <div className="advanced-setting-title">
                    <h3>{I18n.get('LABEL-AI-USAGE-RANGE')}</h3>
                </div>
                <div className="groupSettingContent">
                    <div className="groupSettingItem">
                        <div className="select-check">
                            <input
                                className="ai-checkbox"
                                type="checkbox"
                                id="isInProject"
                                defaultChecked={getValue(settingData, 'isInProject')}
                                checked={getValue(settingData, 'isInProject')}
                                onClick={e => onChangeData(e, 'isInProject')}
                            />
                            <label htmlFor="isInProject"></label>
                        </div>
                        <label className="settingLable">{I18n.get('LABEL-PRJ-IN-USE')}</label>
                    </div>
                </div>
                <div className="groupSettingContent">
                    <div className="groupSettingItem">
                        <div className="select-check">
                            <input
                                className="ai-checkbox"
                                type="checkbox"
                                id="isInOrg"
                                defaultChecked={getValue(settingData, 'isInOrg')}
                                checked={getValue(settingData, 'isInOrg')}
                                disabled={!isInProjectCheck()}
                                onClick={e => onChangeData(e, 'isInOrg')}
                            />
                            <label htmlFor="isInOrg"></label>
                        </div>
                        <label className="settingLable">{I18n.get('LABEL-PRJ-IN-ORG')}</label>
                    </div>
                </div>
                <div className="groupSettingContent">
                    <div className="groupSettingItem">
                        <div className="select-check">
                            <input
                                className="ai-checkbox"
                                type="checkbox"
                                id="isOutOrg"
                                defaultChecked={getValue(settingData, 'isOutOrg')}
                                checked={getValue(settingData, 'isOutOrg')}
                                disabled={!isInProjectCheck()}
                                onClick={e => onChangeData(e, 'isOutOrg')}
                            />
                            <label htmlFor="isOutOrg"></label>
                        </div>
                        <label className="settingLable">{I18n.get('LABEL-PRJ-OUT-ORG')}</label>
                    </div>
                </div>
            </div>
            <div className="groupSetting category-active">
                <div className="advanced-setting-title">
                    <h3>{I18n.get('TITLE_AI_LOG')}</h3>
                </div>
                <div className="groupSettingContent">
                    <div className="groupSettingItem">
                        <div className="select-check">
                            <input
                                className="ai-checkbox"
                                type="checkbox"
                                id="isInProject"
                                checked={isShowLogAiChat}
                                onClick={onChangeButtonViewLogAI}
                            />
                            <label htmlFor="isInProject"></label>
                        </div>
                        <label className="settingLable label-view-log">{I18n.get('LABEL_AI_LOG')}</label>
                    </div>
                </div>
            </div>

            <div className="groupSetting category-active">
                <div className="advanced-setting-title">
                    <h3>{I18n.get('TITLE_MAX_AI_CHAT_KNOWLEDGE_COUNT')}</h3>

                    <div className="org-setting-ai-chatgpt-header-right" onClick={() => setIsShowMsgSettingMaxKnowledge(true)}>
                        <img className='title-name' src="/assets/image/icon-reset.svg" alt="reset"/>
                        <div className="title-name">{I18n.get('ORG-INFOR-LABEL-RESET')}</div>
                    </div>
                </div>
                <div className="groupSettingContent d-flex justify-between">
                    <label className="setting-label-text">
                        <span>{I18n.get('LABEL_MAX_AI_CHAT_KNOWLEDGE_COUNT')}</span>
                        <span className="required">*</span>
                    </label>
                    <TextField
                        className="form-control-input form-control-wrapInput form-control-hg32 setting-input"
                        variant="outlined"
                        spellCheck={false}
                        type="text"
                        value={maxAiChatKnowledgeCount.value}
                        onChange={e => handleOnChangeMaxAiChatKnowledgeCount(e)}
                        onBlur={e => handleOnBlurMaxAiChatKnowledgeCount(e)}
                        helperText={maxAiChatKnowledgeCount.error}
                        error={!Utils.isEmptyString(maxAiChatKnowledgeCount.error)}
                    />
                </div>
            </div>

            <div className="groupSetting category-active">
                <div className="advanced-setting-title">
                    <h3>{I18n.get('TITLE_AI_RESPONSE_MESSAGE_RANDOMNESS')}</h3>

                    <div className="org-setting-ai-chatgpt-header-right" onClick={() => setIsShowMsgSettingAI(true)}>
                        <img className='title-name' src="/assets/image/icon-reset.svg" alt="reset"/>
                        <div className="title-name">{I18n.get('ORG-INFOR-LABEL-RESET')}</div>
                    </div>
                </div>
                <div className="groupSettingContent d-flex justify-between">
                    <label className="setting-label-text">
                        <span>{I18n.get('LABEL_AI_RESPONSE_MESSAGE_RANDOMNESS')}</span>
                        <span className="required">*</span>
                    </label>
                    <TextField
                        className="form-control-input form-control-wrapInput form-control-hg32 setting-input"
                        variant="outlined"
                        spellCheck={false}
                        type="text"
                        value={temperature.value}
                        onChange={e => handleOnChangeTemperature(e)}
                        onBlur={e => handleOnBlurTemperature(e)}
                        helperText={temperature.error}
                        error={!Utils.isEmptyString(temperature.error)}
                    />
                </div>
            </div>

            <ConfirmDialog
                isOpen={isShowDialogReload}
                msgConfirm={I18n.get('COMMSG030')}
                okCallBack={() => {
                    closePanelTab({
                        event: null,
                        panelType: props.panelType,
                        panelId: props.panelId,
                        tabId: props.tabId
                    });

                    window.location.reload()
                }}
            />
            <ConfirmDialog
                isOpen={isOpenConfirmReset}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={() => {
                    setIsOpenConfirmReset(false);
                    handleSubmitSetting()
                } 
                }
                closeCallBack={() => {
                    setReloadPage(Date.now().toString());
                    setIsOpenConfirmReset(false);
                }}
                cancelCallBack={() => {
                    setIsOpenConfirmReset(false);
                }}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
                isShowClassnameButton={false}
            />

            <ConfirmDialog
                isOpen={isConfirmCancelTabs}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={() => {
                    setIsConfirmCancelTabs(false);
                    handleSubmitSetting()
                } 
                }
                closeCallBack={() => {
                    closePanelTab({
                        event: null,
                        panelType: props.panelType,
                        panelId: props.panelId,
                        tabId: props.tabId
                    });
                }}
                cancelCallBack={() => {
                    setIsConfirmCancelTabs(false);
                }}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
                isShowClassnameButton={false}
            />

            <ConfirmDialog
                isOpen={isShowMsgSettingAI}
                msgConfirm={I18n.get('MSG-CM-BACK-TO-DEFAULT-TEMPERATURE')}
                closeCallBack={() => {
                    setIsShowMsgSettingAI(false);
                }}
                okCallBack={handlerResetAISetting}
                textSubmit={I18n.get('CM-BUTTON-OK')}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
            />

            <ConfirmDialog
                isOpen={isShowMsgSettingMaxKnowledge}
                msgConfirm={I18n.get('MSG-CM-BACK-TO-DEFAULT-MAX-AI-CHAT-KNOWLEDGE-COUNT')}
                closeCallBack={() => {
                    setIsShowMsgSettingMaxKnowledge(false);
                }}
                okCallBack={handlerResetMaxAiChatKnowledgeCount}
                textSubmit={I18n.get('CM-BUTTON-OK')}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
            />
        </div>
    );
}
